<script>
  import _isEqual from 'lodash/isEqual'
  import VueElementLoading from 'vue-element-loading'
  import {
    documentMethods,
    userMethods,
  } from '@state/helpers'

  export default {
    components: {
      VueElementLoading,
    },
    props: {
      projectId: {
        type: null,
        default: null,
      },
      hideFilters:{
        type: Boolean,
        default: false,
      },
      customFilters:{
        type: null,
        default: null,
      },
      customClasses:{
        type: String,
        default: '',
      },
      forcePadding:{
        type: Boolean,
        default: false,
      },
      defaultFilters: {
        type: Object,
        default: () => {},
      },
      hideColumns: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        documents: {},
        loadingStack: [true],
        filter: {},
        blockFilters: ['docTypesFilter'],
        collapseFilters: ['docTypesFilter'],
      }
    },
    computed: {
      reactiveCustomFilters(){
        return this.customFilters
      },
      finishedLoading(){
        return this.loadingStack.length === 0
      }
    },
    async created() {
      this.filter = {
        ...this.defaultFilters,
        ...this.filter,
      }

      // init value
      this.loadData(!!(this.customFilters))

      // dynamically create watcher AFTER init for future changes
      this.$watch('filter', function (newVal, oldVal) {
        if(this._isEqual(newVal,oldVal)) return;
        this.loadingStack.push(true)
        this.loadData(!!(this.customFilters))
      })
      this.$watch('reactiveCustomFilters', function (newVal, oldVal) {
        if(this._isEqual(newVal,oldVal)) return;
        this.loadingStack.push(true)
        this.loadData(!!(this.customFilters))
      })
    },
    methods: {
      ...documentMethods,
      ...userMethods,
      _isEqual,
      async loadData(useCustom) {
        let params = {
          ...this.filter,
          project_id: this.projectId,
          sortedBy: "desc",
          orderBy: "updated_at"
        }
        if (useCustom){
          params = {
            ...this.customFilters,
            project_id: this.projectId,
            sortedBy: "desc",
            orderBy: "updated_at"
          }
        }
        this.documents = (await this.resolveDocuments( params)).data.data
        this.loadingStack.shift()
      },
      tryToFilterData (filter) {
        this.filter = {
          ...this.filter,
          ...filter,
          page: 1,
        }
      },
    },
  }
</script>

<template>
  <section>
    <VueElementLoading :active="!finishedLoading" spinner="bar-fade-scale"  class="pd-t-40 bg-col-transparent"/>
    <div v-if="finishedLoading" class="tw-pr-2 scroll-y scroll-primary-sm" :class="customClasses">
      <div class="add-address-content">
        <section v-if="documents.length !== 0">
          <div
            v-for="(document, index) in documents"
            :key="document.id"
            :class="['row no-gutters align-items-center address-item  pd-r-u pd-r-15-i', { 'mg-t-10': (forcePadding && index !== 0) }]"
          >
            <BaseDocumentListEntity :value="document" :hide-columns="hideColumns" wrapper-classes="fl-left-right p-w-100"/>
          </div>
        </section>
        <section v-else>
          <div class="row no-gutters align-items-center address-item">
            <div class="text-bold">
              No documents have been created yet
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>
